module.exports = __webpack_public_path__ + "img/sy.9e93aeaa.svg";